// Vendor imports
const { connect } = require('react-redux')
// Client V2 common imports
const withImmutableToJS = require('client-v2/common/components/immutable-to-js')
const authModalActions = require('client-v2/common/containers/auth-modal/actions')
const searchFormActions = require('client-v2/common/containers/search-form/actions')
const searchFormSelectors = require('client-v2/common/containers/search-form/selectors')
const articleActions = require('client-v2/common/models/article/actions')
const userActions = require('client-v2/common/models/user/actions')
// Sibling imports
const AppHeader = require('./component-dumb')

function mapStateToProps(state) {
  return {
    hidden: state.env.nativeEmbedded,
    isSearchVisible: searchFormSelectors.isVisible(state),
    user: state.user.loggedIn ? state.user : null
  }
}

const mapDispatchToProps = {
  // Common actions
  onSearchClick: searchFormActions.show,
  // Logged-in actions
  onAddClick: articleActions.showAddUrlModal,
  onProfileClick: userActions.navigateToUserProfile,
  onSharedClick: userActions.navigateToShared,
  // Logged-out actions
  onLoginClick: authModalActions.showLogin,
  onSignupClick: authModalActions.showSignup
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withImmutableToJS(
    AppHeader
  )
)
